const errors = {
  "thunk/db/not-found": "invites.errors.not_found",
  "thunk/invites/invites-out": "invites.errors.invites_out",
  "thunk/invites/user-exists": "invites.errors.user_exists",
  "thunk/connection-error": "errors.common.connection_error",
};

export const getErrorInfo = (error = {}) => {
  //  @ts-ignore ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  const message = errors[error.code];

  if (message != null) {
    return {
      message,
      //  @ts-ignore ts-migrate(2339) FIXME: Property 'code' does not exist on type '{}'.
      code: error.code,
    };
  }

  return {
    message: "invites.errors.unknown",
    //  @ts-ignore ts-migrate(2339) FIXME: Property 'code' does not exist on type '{}'.
    code: error.code,
  };
};
